import emailsubscribe from '../img/emailsubscribe.png';
import EmailMe from '../img/EmailMe.png';
var sectionStyle = {
    backgroundImage: "url(" + { emailsubscribe } + ") no-repeat center center;"
};
export default function Newsletter() {
    return <>
        <div className='pt-3' >
            <div className='newsletter ' style={{ backgroundImage: 'url(' + emailsubscribe + ')', backgroundSize: 'auto' }} >
                <div className='container' >
                    <div className='row align-items-center py-4 py-md-5 ' >
                        <div className='col-lg-8 pe-lg-5' >
                            <div className='row align-items-center pb-4' >
                                <div className=' col-sm-9 col-lg-12' >
                                    <h2>Keep up with Exquisite Moves!</h2>
                                    <p>Be the first to know about new & exclusive offers on Exquisite Moves, Subscribe to our newsletter.</p>
                                </div>
                                <div className='col-3 col-sm-3 d-none d-sm-block d-lg-none' >
                                    <img src={EmailMe} className="img-fluid" alt="image" />
                                </div>
                            </div>
                            <div className='subscribeField' >
                                <input className='form-control' type="email" placeholder='Enter your email here ..' />
                                <button>Subscribe &nbsp; &nbsp;&nbsp; <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.2" d="M10.5 2.25C15.3256 2.25 19.25 6.17525 19.25 11C19.25 15.8247 15.3256 19.75 10.5 19.75C5.67525 19.75 1.75 15.8247 1.75 11C1.75 6.17525 5.67525 2.25 10.5 2.25" fill="white" />
                                    <path d="M9.23774 7.30693C9.40486 7.30693 9.57286 7.3708 9.70061 7.49855L12.7517 10.5348C12.8751 10.6582 12.9442 10.8253 12.9442 11.0003C12.9442 11.1744 12.8751 11.3416 12.7517 11.4649L9.70061 14.5029C9.44424 14.7584 9.02949 14.7584 8.77311 14.5012C8.51761 14.2439 8.51849 13.8283 8.77486 13.5728L11.3587 11.0003L8.77486 8.4278C8.51849 8.1723 8.51761 7.75755 8.77311 7.5003C8.90086 7.3708 9.06974 7.30693 9.23774 7.30693" fill="white" />
                                </svg>
                                </button>
                            </div>
                        </div>
                        <div className='col-md-4 d-none d-lg-block' >
                            <img src={EmailMe} className="img-fluid" alt="image" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
}